export class PaymentAmountForDoctorModel {
  DoctorARLocId : string;
  DoctorName : string;
  amount: number;
  isSelected: boolean;
  PaymentProcessorId: string;
  ARAccountID: string;

}
